import React, { ChangeEvent, useEffect } from "react";
import styles from "./ShoppingList.module.scss";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { Section } from "@/components/Global/Section/Section";
import { Input } from "@/components/Global/Input/Input";
import { deleteFromShoppingList } from "@/utils/serviceAPI/shoppinglist";
import { toast } from "react-toastify";
import {
  onClickPdfDownload,
  PrintListItem,
} from "@/components/RecipeComponents/RecipeSingleView/PDFDownloadButton/PDFDownloadButton";
import { Loader } from "@/components/Loader/Loader";
import { Button, SubmitButton } from "@/components/Global/Button/Button";
import { ReactSVG } from "react-svg";
function ShoppingList() {
  const { shoppingListRecipes, setShoppingList, loading, setLoading } =
    useAppContext();
  const { getLabel, getIcon } = useGlobalContext();
  const [printList, setPrintList] = React.useState<PrintListItem[]>(
    shoppingListRecipes?.map((recipe, i) => ({
      item: recipe,
      index: i,
    })) || [],
  );
  useEffect(() => {
    if (printList.length === 0 && shoppingListRecipes?.length) {
      setPrintList(
        shoppingListRecipes?.map((recipe, i) => ({
          item: recipe,
          index: i,
        })) || [],
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoppingListRecipes]);
  async function removeRecipe(item: PrintListItem) {
    const id = item.item.rezept_id;
    const res = await deleteFromShoppingList(id);
    if (res) {
      toast(getLabel("shopping_list_recipe_removed"));
      removeFromPrintList(item);
    }
    setShoppingList();
  }

  function addToPrintList(itemToHandle: PrintListItem) {
    setPrintList(
      [...printList, itemToHandle].sort((a, b) => a.index - b.index),
    );
  }

  function removeFromPrintList(itemToHandle: PrintListItem) {
    setPrintList(
      printList.filter(
        (item) => item.item.rezept_id != itemToHandle.item.rezept_id,
      ),
    );
  }

  function handleCheckBox(
    e: ChangeEvent<HTMLInputElement>,
    itemToHandle: PrintListItem,
  ) {
    if (e.target.checked) {
      addToPrintList(itemToHandle);
    } else {
      removeFromPrintList(itemToHandle);
    }
  }
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onClickPdfDownload({
      getLabel,
      getIcon,
      printList,
      pdfType: "shopping-list",
      setLoading,
    });
  }
  return (
    <Section columnsClassName="is-centered" className={styles["shopping-list"]}>
      <div className="column is-10-tablet is-8-fullhd">
        {!loading && (
          <>
            <p aria-live="polite">
              {shoppingListRecipes && shoppingListRecipes.length
                ? shoppingListRecipes.length
                : 0}{" "}
              {getLabel("recipe")}
            </p>
            {shoppingListRecipes && shoppingListRecipes.length > 0 ? (
              <form onSubmit={handleSubmit}>
                <ul>
                  {shoppingListRecipes.map((recipe, i) => (
                    <li key={`shopping-list-recipe-${i}`}>
                      <Input
                        id={`shopping-list-recipe-${recipe.rezept_id}`}
                        name={`recipe-${recipe.rezept_id}`}
                        inputType="checkbox"
                        onChange={(e) =>
                          handleCheckBox(e as ChangeEvent<HTMLInputElement>, {
                            item: recipe,
                            index: i,
                          })
                        }
                        className=""
                        label_checkbox={recipe.rezept_titel}
                        checked={printList.some(
                          (item) => item.item.rezept_id === recipe.rezept_id,
                        )}
                      ></Input>
                      <p className={styles["recipe-portion"]}>
                        {recipe.portionsgroesse ||
                          recipe.anzahl_portionen_big +
                            " " +
                            getLabel("portions")}
                      </p>
                      <button
                        type="button"
                        className={`button-reset ${styles["delete-button"]}`}
                        onClick={() =>
                          removeRecipe({
                            item: recipe,
                            index: i,
                          })
                        }
                        aria-label={getLabel(
                          "shopping_list_remove_recipe",
                        ).replace("$$title", recipe.rezept_titel)}
                      >
                        <ReactSVG
                          src={getIcon("close")}
                          width={20}
                          height={20}
                          wrapper="svg"
                          beforeInjection={(svg) => {
                            svg.setAttribute("aria-hidden", "true");
                            svg.setAttribute("width", "20");
                            svg.setAttribute("height", "20");
                          }}
                          aria-hidden
                        />
                      </button>
                    </li>
                  ))}
                </ul>
                <Button
                  icon="circlePlus"
                  type="primary"
                  href={`/rezepte`}
                  target="_self"
                  className="mx-auto my-6"
                >
                  {getLabel("add_recipes")}
                </Button>
                <SubmitButton
                  className="ghost is-primary"
                  icon={"circleDownload"}
                >
                  {getLabel("download_shopping_list")}
                </SubmitButton>
              </form>
            ) : (
              <p>{getLabel("no_recipes_in_shopping_list")}</p>
            )}
          </>
        )}
        {loading && <Loader />}
      </div>
    </Section>
  );
}

export default ShoppingList;
